import {Action, Dispatch} from 'redux';
import {ApiActionCall, ApiActionTypes} from './Api';
import {logger} from '../../shared/logger';
import {showError} from './Common';
import {NOTIFICATIONS_URL} from '../../@crema/services/ApiConfig';
import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_ERROR,
  FETCH_NOTIFICATIONS_SUCCESS,
  NotificationsActionTypes,
} from '../../types/actions/Notifications.action';
import {INotifications} from '../../types/models/Notifications';
import {EventSourceActionTypes} from '../../types/actions/EventSource.actions';

export const fetchNotifications = () => async (
  dispatch: Dispatch<
    ApiActionCall | NotificationsActionTypes | EventSourceActionTypes
  >,
) => {
  dispatch({type: FETCH_NOTIFICATIONS});

  const onSuccess = (payload: INotifications[]) => {
    /* dispatch({
      type: ADD_EVENT_SOURCE,
      payload: {
        url: NOTIFICATIONS_LIVE_URL,
        onMessage: (e) => {
          const data: {message: string; timestamp: string} = JSON.parse(e.data);
          dispatch({
            type: ADD_NOTIFICATION,
            payload: {
              // @ts-ignore
              id: e.id, // probably should be last-event-id need to be tested
              message: data.message,
              timestamp: data.timestamp,
              active: true,
            },
          });
        },
      },
    }); */
    return {
      type: FETCH_NOTIFICATIONS_SUCCESS,
      payload: payload,
    };
  };
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_NOTIFICATIONS_ERROR});
    dispatch(showError('Failed to fetch Notifications data.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: NOTIFICATIONS_URL,
      method: 'GET',
      label: 'Fetch Notification data',
      onSuccess,
      onFailure,
    },
  });
};
